// Pure, shared locale rules. Language never changes currency, skill IDs or API payloads.
export const languages = [['en','English'],['es','Español'],['pt-BR','Português (Brasil)'],['fr','Français'],['ar','العربية'],['hi','हिन्दी'],['bn','বাংলা'],['el','Ελληνικά'],['it','Italiano'],['ru','Русский'],['uk','Українська'],['tr','Türkçe'],['de','Deutsch']];
export const storageKey = 'earlybird:language';
export function supported(value) {
 if(typeof value!=='string')return null;
 const base=value.toLowerCase().split(/[-_]/)[0];
 return languages.find(([code])=>code.toLowerCase().split('-')[0]===base)?.[0] || null;
}
export function detectLanguage(saved,preferred=[]) {
 return supported(saved)||preferred.map(supported).find(Boolean)||'en';
}
export function translate(dictionary,value,params) {
 if(typeof value!=='string')return value;
 const key=value.trim();
 if(!key)return value;
 const result=Object.prototype.hasOwnProperty.call(dictionary,key)?dictionary[key]:key;
 const translated=value.slice(0,value.indexOf(key))+result+value.slice(value.indexOf(key)+key.length);
 return params ? translated.replace(/\{(\d+)\}/g,(match,n)=>params[n]===undefined?match:String(params[n])) : translated;
}

export function currentLocale(){return typeof document==='undefined'?'en':document.documentElement.lang||'en';}
